import { ActionsObservable, combineEpics } from "redux-observable";
import { filter, switchMap, map, catchError } from "rxjs/operators";

import { of } from "rxjs";
import { HouseholdClaimRepository } from "src/containers/household-claim/repositories/claim/household-claim.repository";
import { HouseholdClaimService } from "src/containers/household-claim/services/claim/household-claim.service";
import { HttpClient } from "src/infra/http/client";
import { HttpUtils } from "src/infra/http/utils";
import {
    HouseholdClaimLoadSummariesAction,
    householdClaimLoadSummaries,
    householdClaimFillSummaries,
    householdClaimErrorSummaries,
} from "src/redux/claim/household/actions";

export function loadHouseholdClaimEpic(
    action$: ActionsObservable<HouseholdClaimLoadSummariesAction>
) {
    const householdService = new HouseholdClaimService(
        new HouseholdClaimRepository(new HttpClient(new HttpUtils()))
    );
    return action$.pipe(
        filter(householdClaimLoadSummaries.match),
        switchMap(() => {
            return householdService.getClaims().pipe(
                map((claims) => householdClaimFillSummaries(claims)),
                catchError((error) => of(householdClaimErrorSummaries(error)))
            );
        })
    );
}

export const householdClaimEpics = combineEpics(loadHouseholdClaimEpic);
